import React, { forwardRef, useImperativeHandle, useState } from "react";
import { Modal } from "antd";
import applyFlowIcon from "../../assets/images/apply-flow.png";

const ApplyFlow = ({}, ref) => {
  const [open, setOpen] = useState(false);
  useImperativeHandle(
    ref,
    () => ({
      openApplyFlow,
    }),
    []
  );

  const openApplyFlow = () => {
    setOpen(true);
  };

  const onCancel = () => {
    setOpen(false);
  };
  return (
    <Modal
      title={"一图读懂"}
      open={open}
      visible={open}
      onCancel={onCancel}
      destroyOnClose={true}
      maskClosable={false}
      mask={false}
      footer={null}
      width={837}
    >
      <img src={applyFlowIcon} alt="" />
    </Modal>
  );
};

export default forwardRef(ApplyFlow);
